<div class="card card-alter-height {{config?.css}}">
  <app-card-header *ngIf="config && config.headerConfig"
                   [config]="config.headerConfig"
                   [extraText]="extraTitleText"
                   (onActionClick)="onActionClick.emit($event)"
  ></app-card-header>
  <ng-content></ng-content>
</div>
